import { useEffect, useState } from 'react';

const ImageUploadWithPreview = ({ uploadFile, defaultImageURL }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState('../assets/images/userprofile.png');

  // Allowed file types and maximum file size (in bytes)
  const allowedTypes = ['image/png', 'image/jpeg'];
  const maxSize = 5 * 1024 * 1024; // 5 MB

  // Handle file selection and validation
  const handleFileChange = (event) => {
    let file = event.target.files[0];
    let fileError = null;

    if (!allowedTypes.includes(file.type)) {
      fileError = 'Invalid file type. Only PNG or JPEG files are allowed.';
    } else if (file.size > maxSize) {
      fileError = 'File size must be less than 5 MB.';
    } else {
      // Set selectedFile with a single validated file
      setSelectedFile({
        file,
        preview: URL.createObjectURL(file),
      });
      setImageUrl(imageUrl);
      uploadFile(file);
    }

    // Update error message if validation fails
    setError(fileError);
  };

  const handleRemoveImage = () => {
    setSelectedFile(null);
    setImageUrl(null);
  };
  useEffect(() => {
    if (defaultImageURL) {
      setImageUrl(defaultImageURL);
    }
  }, [defaultImageURL]);

  return (
    <div className="file-upload">
      <div className="userPreview">
        <div className="userImage">
          {!selectedFile && (
            <img src={imageUrl} alt="Preview" style={{ width: '100%', height: '100%' }} />
          )}
          {selectedFile && selectedFile?.file?.type.includes('image') && (
            <img
              src={selectedFile.preview}
              alt="Preview"
              style={{ width: '100%', height: '100%' }}
            />
          )}

          <input
            type="file"
            id="fileInput"
            onChange={handleFileChange}
            accept=".png, .jpeg, .jpg"
            style={{ display: 'none' }}
          />
        </div>

        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button
          className="btn editPencil"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('fileInput').click();
          }}
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 5V19M12 5L6 11M12 5L18 11"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      <span className="imageName"> {selectedFile ? selectedFile.file.name : ''}</span>
    </div>
  );
};

export default ImageUploadWithPreview;
